import { useContext } from "react";
import products from "../data/products.json";
import ProductCard from "../components/ProductCard";
import { CartContext } from "../context/CartContext";  
import "./Shop.css";  // ✅ import CSS

function Shop() {
  const { addToCart } = useContext(CartContext);

  return (
    <div className="container py-5">
      {/* Shop heading with subtitle */}
      <div className="shop-heading text-center mb-5">
        <h1 className="shop-title">Produktet Tona</h1>
        <p className="shop-subtitle">
          Zgjidhni shijen tuaj të preferuar, freski & shëndet 🌿
        </p>
      </div>

      {/* Products */}
      <div className="row g-4">
        {products.map((product) => (
          <div className="col-md-4" key={product.id}>
            <ProductCard product={product} onAddToCart={addToCart} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
